import { createMessage, SB } from '@play-co/replicant';
import createMessages from '../config/messages/createMessages';
import * as Friends from '../friends';
import features from '../ruleset/features';
import { friendJoinedViaReferral } from './social.modifiers';

export const socialMessages = createMessages({
  /**
   * Notify current user that a referral friend was added.
   * This is when the friend is already in the game before.
   */
  referralFriendAdded: createMessage(
    SB.object({}),
    (state, _, { senderId, timestamp }) => {
      // Automatically add the existing player who entered via the share link
      // as a friend for enabled in-game friends feature flag
      Friends.modifiers.addFriend(state, senderId, timestamp);
    },
  ),

  /**
   * Notify current user that his friend joined over his invite
   */
  referralFriendJoined: createMessage(
    SB.object({}),
    (state, _, { senderId, timestamp }) => {
      if (!features(state).addFriendsV2) {
        // Automatically add new player who joined via the share link as a friend
        // for enabled in-game friends feature flag
        friendJoinedViaReferral(state, senderId, timestamp);
      }
    },
  ),

  /**
   * Notify current user that his friend can be visited.
   *
   * Phase B (public profile ready):
   * - Add the invitee to the inviter's friend list (reciprocal connection) if needed
   * - Grant referral reward if Phase A deferred `referralFriendJoined`
   */
  referralFriendVisitUnlocked: createMessage(
    SB.object({
      name: SB.string(),
      photo: SB.string(),
      frame: SB.string().optional(),
    }),
    (state, { name, photo, frame }, { senderId, timestamp }) => {
      state.social.referral.visitableFriend = {
        friendId: senderId,
        name,
        photo,
        frame: frame ?? 'default',
        createdAt: timestamp,
      };

      // Phase B: reciprocal add + reward for Add Friends V2 users
      if (features(state).addFriendsV2) {
        // Add invitee as friend on inviter side.
        friendJoinedViaReferral(state, senderId, timestamp);
      }
    },
  ),
});
